import { Star } from 'lucide-react'
import { cn } from '@/utils/helpers'

const RATING_LABELS: Record<number, string> = {
  1: 'Très mauvaise',
  2: 'Mauvaise',
  3: 'Moyenne',
  4: 'Bien',
  5: 'Très bien'
}

type StarRatingProps = {
  rating: number | null
  onRatingChange: (rating: number) => void
  size?: 'md' | 'lg'
  className?: string
  disabled?: boolean
}

export function StarRating({ rating, onRatingChange, className, size = 'md', disabled = false }: StarRatingProps) {
  return (
    <div className={cn('flex flex-col items-center gap-4', className)}>
      <div className="flex gap-2">
        {[1, 2, 3, 4, 5].map((starValue) => {
          const isFilled = rating !== null && starValue <= rating
          return (
            <button
              key={starValue}
              type="button"
              onClick={() => onRatingChange(starValue)}
              disabled={disabled}
              className="rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
              aria-label={`Noter ${starValue} étoile${starValue > 1 ? 's' : ''}: ${RATING_LABELS[starValue]}`}
            >
              <Star
                className={cn(
                  'h-8 w-8 transition-colors',
                  size === 'lg' ? 'h-10 w-10' : '',
                  isFilled ? 'fill-yellow-300 text-yellow-300' : 'fill-gray-300 text-transparent'
                )}
              />
            </button>
          )
        })}
      </div>
      {rating !== null && <p className="text-sm font-medium">{RATING_LABELS[rating]}</p>}
    </div>
  )
}
